
import React from 'react';

interface HexagramViewProps {
  lines: number[]; // 6 lines, bottom to top
  changingIndex?: number; // 1-6
  title: string;
}

const HexagramView: React.FC<HexagramViewProps> = ({ lines, changingIndex, title }) => {
  const displayLines = [...lines].reverse();

  return (
    <div className="flex flex-col items-center gap-2 md:gap-4">
      <div className="relative">
        <h4 className="text-amber-400 font-bold mb-2 md:mb-4 text-[12px] md:text-sm tracking-[0.2em] md:tracking-[0.4em] text-center border-b border-amber-500/20 pb-1 md:pb-2 drop-shadow-sm whitespace-nowrap">
          {title}
        </h4>
        <div className="absolute -top-3 -left-2 md:-left-3 w-4 md:w-6 h-4 md:h-6 border-t border-l border-amber-500/20"></div>
        <div className="absolute -bottom-1 md:-bottom-2 -right-2 md:-right-3 w-4 md:w-6 h-4 md:h-6 border-b border-r border-amber-500/20"></div>
      </div>
      
      <div className="flex flex-col gap-1.5 md:gap-2 w-20 md:w-24 relative group">
        {displayLines.map((line, idx) => {
          const actualIndex = 6 - idx;
          const isChanging = actualIndex === changingIndex;
          const delay = (5 - idx) * 0.1 + 0.3;

          return (
            <div 
              key={idx} 
              className={`h-2 md:h-2.5 flex gap-1 md:gap-1.5 relative transition-all duration-500 ${isChanging ? 'scale-110' : 'opacity-90 group-hover:opacity-100'}`}
              style={{ 
                animation: `fadeIn 0.6s ease-out ${delay}s forwards`,
                opacity: 0
              }}
            >
              {line === 1 ? (
                <div className={`w-full h-full rounded-[1px] transition-all duration-1000 ${
                  isChanging 
                  ? 'bg-amber-400 shadow-[0_0_15px_rgba(251,191,36,0.8)]' 
                  : 'bg-slate-50 shadow-[0_0_8px_rgba(255,255,255,0.1)]'
                }`} />
              ) : (
                <>
                  <div className={`w-[45%] h-full rounded-[1px] transition-all duration-1000 ${
                    isChanging 
                    ? 'bg-amber-400 shadow-[0_0_15px_rgba(251,191,36,0.8)]' 
                    : 'bg-slate-50 shadow-[0_0_8px_rgba(255,255,255,0.1)]'
                  }`} />
                  <div className="w-[10%] h-full" />
                  <div className={`w-[45%] h-full rounded-[1px] transition-all duration-1000 ${
                    isChanging 
                    ? 'bg-amber-400 shadow-[0_0_15px_rgba(251,191,36,0.8)]' 
                    : 'bg-slate-50 shadow-[0_0_8px_rgba(255,255,255,0.1)]'
                  }`} />
                </>
              )}
              {isChanging && (
                <div className="absolute -left-4 md:-left-6 top-0 bottom-0 flex items-center">
                  <span className="text-amber-400 animate-pulse text-[6px] md:text-[8px]">✦</span>
                </div>
              )}
              {isChanging && (
                <div className="absolute -right-4 md:-right-6 top-0 bottom-0 flex items-center">
                  <span className="text-amber-400 animate-pulse text-[6px] md:text-[8px]">✦</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HexagramView;
